import { gql } from '@apollo/client';

/* ── the mutual fund research analyst — interactive sessions ───────────────
   A session is one fund plan researched in conversation: it opens on the
   fund's research facts (and the note from its last published report, or a
   fresh narration), the chat (subscriptions/mfAnalyst.js) and the edit
   mutations write revisions, finalise is proposed in chat and confirmed here,
   and closing ends it. Start and chat need RESEARCH_ANALYST or RESEARCH_LEAD;
   the reads need an employee login. */

/** One session: status, revisions, statements, assumptions, and once finalised the published research. */
export const MF_ANALYST_SESSION = gql`
  query MfResearchAnalystSession($sessionId: Int!) {
    mfResearchAnalystSession(sessionId: $sessionId) {
      id
      securitySymbol
      researchWindow
      status
      title
      currentRevisionId
      finalRevisionId
      statements
      assumptions
      factsAsOf
      basedOnSessionId
      mfResearchId
      reviewId
      updatedAt
    }
  }
`;

/** The reader's MF sessions, newest first; narrowed to one fund when given. */
export const MF_ANALYST_SESSIONS = gql`
  query MfResearchAnalystSessions($securitySymbol: String, $limit: Int) {
    mfResearchAnalystSessions(securitySymbol: $securitySymbol, limit: $limit) {
      id
      securitySymbol
      researchWindow
      status
      currentRevisionId
      finalRevisionId
      createdAt
    }
  }
`;

/** The note's history, oldest first. */
export const MF_ANALYST_REVISIONS = gql`
  query MfResearchAnalystRevisions($sessionId: Int!) {
    mfResearchAnalystRevisions(sessionId: $sessionId) {
      id
      revisionNumber
      author
      changeSummary
      headline
      conflicts
      adjustedGrades
      isFinal
      createdAt
    }
  }
`;

/** One revision as markdown or html, with its statements, assumptions, results and conflicts. */
export const MF_ANALYST_REVISION = gql`
  query MfResearchAnalystRevision($revisionId: Int!, $format: String = "markdown") {
    mfResearchAnalystRevision(revisionId: $revisionId, format: $format) {
      format
      body
      revision {
        id
        sessionId
        revisionNumber
        headline
        statements
        assumptions
        results
        conflicts
        adjustedGrades
        changeSummary
        isFinal
        pdfS3Key
        mfResearchId
        reviewId
      }
    }
  }
`;

/**
 * What a publishable note must be for this fund — the research writer's
 * instructions and output contract, the areas allowed and the ones this
 * edition MUST answer, the caps, the card's grade and call. A JSON scalar.
 */
export const MF_ANALYST_NOTE_CONTRACT = gql`
  query MfResearchAnalystNoteContract($sessionId: Int!) {
    mfResearchAnalystNoteContract(sessionId: $sessionId)
  }
`;

/** The publish checks WITHOUT publishing: `{ clean, errors }`. Finalise only a clean note. */
export const MF_ANALYST_NOTE_CHECK = gql`
  query MfResearchAnalystNoteCheck($sessionId: Int!) {
    mfResearchAnalystNoteCheck(sessionId: $sessionId)
  }
`;

/** What the analyst proposed and its status. */
export const MF_ANALYST_PENDING_ACTIONS = gql`
  query MfResearchAnalystPendingActions($sessionId: Int!) {
    mfResearchAnalystPendingActions(sessionId: $sessionId) {
      id
      action
      status
      preview
      proposedAt
      expiresAt
      result
    }
  }
`;
